import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './lgy-pagination.scss'

const propTypes = {
  items: PropTypes.array.isRequired,
  onPageChange: PropTypes.func.isRequired,
  initialPage: PropTypes.number
}

const defaultProps = {
  initialPage: 1
}

// give "items" prop your data array
// "onPageChange" returns current page items
// see Builder for example
class LgyPagination extends Component {
  state = { pager: {} }

  UNSAFE_componentWillMount() {
    // set page if items array isn't empty
    if (this.props.items && this.props.items.length > 0) {
      this.setPage(this.props.initialPage)
    }
  }

  componentDidUpdate(prevProps) {
    // reset page if items array has changed
    if (this.props.items !== prevProps.items) {
      this.setPage(this.props.initialPage)
    }
  }

  setPage = (page) => {
    let items = this.props.items
    let pager = this.state.pager

    if (page < 1 || page > pager.totalPages) {
      return
    }

    // get new pager object for specified page
    pager = this.getPager(items.length, page)

    // get new page of items from items array
    let pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1)

    // update state
    this.setState({ pager: pager })

    // call change page function in parent component
    this.props.onPageChange(pageOfItems)
  }

  getPager = (totalItems, currentPage, pageSize) => {
    // default to first page
    currentPage = currentPage || 1

    // default page size is 10
    // ToDo: default size will be changed once filtering functionality is added
    // ToDo: Filtering will allow user to select number of records that can be displayed on page 
    // Example: 25,50,100
    pageSize = pageSize || 10

    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize)

    let startPage, endPage
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1
      endPage = totalPages
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1
        endPage = 10
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9
        endPage = totalPages
      } else {
        startPage = currentPage - 5
        endPage = currentPage + 4
      }
    }

    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1)
    // create an array of pages
    const range = (start, end) => (
      Array.from(Array(end - start + 1).keys()).map(i => i + start)
    )
    const pages = range(startPage, endPage)

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    }
  }

  render() {
    let pager = this.state.pager

    return (
      // only display pager if there is more than 1 page
      pager.pages && pager.pages.length > 1 &&
      <ul className='lgy-pagination usa-unstyled-list'>
        <li>
          <button type='button' className='usa-button-secondary' onClick={() => this.setPage(1)} disabled={pager.currentPage === 1}>First</button>
        </li>
        <li>
          <button type='button' className='usa-button-secondary' onClick={() => this.setPage(pager.currentPage - 1)} disabled={pager.currentPage === 1}>Previous</button>
        </li>
        {pager.pages.map((page, index) =>
          <li key={index}>
            <button type='button' className={`usa-button-secondary number-button ${pager.currentPage === page ? 'active-button' : ''}`} onClick={() => this.setPage(page)}>{page}</button>
          </li>
        )}
        <li>
          <button type='button' className='usa-button-secondary next-button' onClick={() => this.setPage(pager.currentPage + 1)} disabled={pager.currentPage === pager.totalPages}>Next</button>
        </li>
        <li>
          <button type='button' className='usa-button-secondary' onClick={() => this.setPage(pager.totalPages)} disabled={pager.currentPage === pager.totalPages}>Last</button>
        </li>
      </ul>
    )
  }
}

LgyPagination.propTypes = propTypes
LgyPagination.defaultProps = defaultProps

export default LgyPagination
